import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useTheme } from '../context/ThemeContext';
import { getMenu } from '../services/front_api';
import { getAccountManagementApp, setActiveApp } from '../services/apps';
// import Modal from './Modal';
// import FilterChooser from './filters/FilterChooser';
import '../css/Modal.css';
import '../css/Header.css';

const getFirstMenuTarget = (items) => {
    if (!Array.isArray(items) || items.length === 0) return '';

    const sortedItems = [...items].sort((a, b) => (a.rank || 0) - (b.rank || 0));

    for (const item of sortedItems) {
        if (item.url) return item.url;

        if (!item.Children || item.Children.length === 0) {
            return `/chart/page/${item.id}`;
        }

        const childTarget = getFirstMenuTarget(item.Children);
        if (childTarget) return childTarget;
    }

    return '';
};

const Header = () => {
    const { themeName, changeTheme, themeLabels } = useTheme();
    const navigate = useNavigate();
    const [accountShortcutLoading, setAccountShortcutLoading] = useState(false);
    const accountManagementApp = getAccountManagementApp();

    // const [isModalOpen, setModalOpen] = useState(false);
    // const handleOpenModal = (e) => {
    //     setModalOpen(true);
    // };

    // const handleCloseModal = () => {
    //     setModalOpen(false);
    // };

    const handleAccountShortcut = async () => {
        if (!accountManagementApp?.id || accountShortcutLoading) return;

        setAccountShortcutLoading(true);
        setActiveApp(accountManagementApp.id);

        try {
            const menu = await getMenu(accountManagementApp.id);
            navigate(getFirstMenuTarget(menu) || '/dashboard');
        } catch (error) {
            console.error('Failed to open account management app:', error);
            navigate('/dashboard');
        } finally {
            setAccountShortcutLoading(false);
        }
    };

    return (
        <div className="header-container">
            <div className="header-left">
                <div id="brand" />
            </div>
            {/* <button type="button" onClick={handleOpenModal}>Filtres Actifs</button> */}
            <div className="header-right">
                <select
                    value={themeName}
                    onChange={(e) => changeTheme(e.target.value)}
                    className="theme-selector"
                >
                    {Object.entries(themeLabels).map(([key, label]) => (
                        <option key={key} value={key}>{label}</option>
                    ))}
                </select>
                <button
                    type="button"
                    className="account-shortcut-btn"
                    onClick={handleAccountShortcut}
                    disabled={!accountManagementApp || accountShortcutLoading}
                    aria-label="Gestion du compte"
                    title={accountManagementApp ? 'Gestion du compte' : 'App Gestion du compte indisponible'}
                >
                    <AccountCircleOutlinedIcon fontSize="small" />
                </button>
                <button
                    type="button"
                    className="logout-btn"
                    onClick={() => navigate('/logout')}
                    aria-label="Se deconnecter"
                    title="Se deconnecter"
                >
                    <LogoutRoundedIcon fontSize="small" />
                </button>
            </div>
        </div>
    );
};

export default Header;
